import { type CSSProperties, lazy, Suspense } from 'react';

import type { VideoPlaybackResolver } from '@/types';

import { HostedVideoPoster } from './HostedVideoPoster';
import type { PodcastHostedVideo } from './PodcastVideo.types';

// Every published page loads these elements, so the player only loads where an episode has a hosted video.
const VideoPlayer = lazy(() => import('@/video/VideoPlayer').then((module) => ({ default: module.VideoPlayer })));

type HostedVideoProps = {
  video: PodcastHostedVideo;
  resolvePlayback: VideoPlaybackResolver;
  translations?: Record<string, string>;
  borderRadius?: CSSProperties['borderRadius'];
};

export const HostedVideo = ({ video, resolvePlayback, translations, borderRadius }: HostedVideoProps) => (
  <div style={{ borderRadius, overflow: 'hidden' }}>
    <Suspense fallback={<HostedVideoPoster posterUrl={video.posterUrl} />}>
      <VideoPlayer
        videoId={video.id}
        resolvePlayback={resolvePlayback}
        poster={video.posterUrl ?? undefined}
        translations={translations}
      />
    </Suspense>
  </div>
);
